import { buyerRepository } from '~/api/repository/buyer';

export const BUYER_QUERY_KEY = {
  all: ['buyer'] as const,

  // 현재 사용자 정보
  current: () => ({
    queryKey: [...BUYER_QUERY_KEY.all, 'current'] as const,
    queryFn: () => buyerRepository.getBuyer(),
  }),

  // 플러스 멤버십 정보
  plusMembership: () => ({
    queryKey: [...BUYER_QUERY_KEY.all, 'plus-membership'] as const,
    queryFn: () => buyerRepository.getBuyerPlusMembership(),
  }),

  // 마이페이지 정보
  myPage: () => ({
    queryKey: [...BUYER_QUERY_KEY.all, 'my-page'] as const,
    queryFn: () => buyerRepository.getBuyerMyPage(),
  }),
};
